import React, { memo } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { TYPOGRAPHY_27 } from 'theme/theme'

const Label = styled.div`
  ${TYPOGRAPHY_27}

  color: #A0A5B3;
`

function LabelComponent ({ label, id, no }) {
  return (
    <div className="mb-60">
      <label htmlFor={id} data-test={`label-${id}`}>
        <Label>
          { no ? <span className="mr-5" style={{ color: '#0bf' }}>{ `${no}.` }</span> : null }
          { label }
        </Label>
      </label>
    </div>
  )
}

export default memo(LabelComponent)

LabelComponent.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  no: PropTypes.number,
  helpText: PropTypes.any
}
